// extracted by mini-css-extract-plugin
module.exports = {"icon-go":"Icon_icon-go__1LkMh","icon-arrow":"Icon_icon-arrow__3jcy7","icon-playIcon":"Icon_icon-playIcon__2buMY"};